var map = {
	"./breakfast.svg": 14371,
	"./champagne.svg": 73650,
	"./dimension.svg": 76252,
	"./location.svg": 30005,
	"./parking.svg": 53840,
	"./people.svg": 16449,
	"./stay.svg": 49259,
	"./view.svg": 9451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91692;